import { searchState, tagsState } from '../state/search'
import { pageState, pageErrorState } from '../state/page'
import {
  resultsState,
  selectedResultsState,
  collaborationState,
  messagesCollaborationState
} from '../state/results'
import {
  fetchMessages,
  exportEmailMessages,
  getActiveMessage,
  getMessagesWithForm,
  getEntitiesThatUseMessage,
  getMessageHtmlExport,
  getMessagePdfExport,
  fetchCollaborationResults,
  getTags
} from '../actions/actions'

import getIntl from 'Helpers/intl'

import {
  beMessApiCopyMessage,
  beMessApiSetArchived,
  beMessApiSetPublic,
  beMessApiGetEntitiesThatUseMessage,
  beMessApiDeleteMessage
} from 'Api/BeMessApi'
import { beSendGoApiExistSendingRunningMessage } from 'Api/beSendGoApi'

import {
  STORE_KEY_ID_LIST,
  MESSAGE_TYPE_WELCOME,
  MESSAGE_TYPE_CONFIRMATION,
  STORE_KEY_USER,
  STORE_KEY_ACCOUNT,
  COLLABORATION_PROJECT_STATUS_OPEN,
  COLLABORATION_PROJECT_STATUS_APPROVED,
  COLLABORATION_PROJECT_STATUS_ARCHIVED
} from 'Constants/'
import { storeGet } from 'Helpers/localStorage'
import { logAppInfo, logAppError } from 'Helpers/logger'
import evalCondition from 'Helpers/evalCondition'
import {
  collaborationApiDeleteProject,
  collaborationApiGetLoginData,
  collaborationApiGetAccountProjects
} from 'Api/collaborationApi'
import { beAccountsApiGetAccountCustomSettings } from 'Api/beAccountsApi'
import { toastShow, TOAST_VARIANT_ERROR } from 'mailup-web-components'

export const searchMessagesCallback = ({ snapshot, set }) => async params => {
  const prevSearchState = await snapshot.getPromise(searchState)

  const searchParams = {
    ...prevSearchState,
    ...params
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  set(searchState, searchParams)

  try {
    const tags = await getTags()
    set(tagsState, tags)

    const [
      results,
      welcomeActiveMessage,
      confirmationActiveMessage
    ] = await Promise.all([
      fetchMessages(searchParams),
      getActiveMessage(MESSAGE_TYPE_WELCOME),
      getActiveMessage(MESSAGE_TYPE_CONFIRMATION)
    ])

    const items = results.Items.map(item => ({
      ...item,
      tags: tags.filter(tag => item.Tags.includes(tag.value)),
      isActiveMessage:
        item.Id === welcomeActiveMessage ||
        item.Id === confirmationActiveMessage
    }))

    const messagesWithForm = await getMessagesWithForm(results.Items)

    set(resultsState, {
      items,
      totalItems: results.TotalItems,
      searchParams,
      messagesWithForm
    })
    // set(selectedResultsState, [])
    set(
      collaborationState,
      results.Items.map(item => item.Id)
    )
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false,
    firstLoading: false
  }))
}
export const resetSelectionCallback = ({ reset }) => async () => {
  reset(selectedResultsState)
}
export const resetSearchCallback = ({ reset, set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  reset(searchState)
  set(selectedResultsState, [])
  try {
    const tags = await getTags()
    set(tagsState, tags)

    const [
      results,
      welcomeActiveMessage,
      confirmationActiveMessage
    ] = await Promise.all([
      fetchMessages(),
      getActiveMessage(MESSAGE_TYPE_WELCOME),
      getActiveMessage(MESSAGE_TYPE_CONFIRMATION)
    ])

    const items = results.Items.map(item => ({
      ...item,
      tags: tags.filter(tag => item.Tags.includes(tag.value)),
      isActiveMessage:
        item.Id === welcomeActiveMessage ||
        item.Id === confirmationActiveMessage
    }))

    const messagesWithForm = await getMessagesWithForm(results.Items)

    set(resultsState, {
      items,
      totalItems: results.TotalItems,
      searchParams: {},
      messagesWithForm
    })
    set(
      collaborationState,
      results.Items.map(item => item.Id)
    )
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}

export const copyMessageCallback = ({ snapshot, set }) => async (
  idMessage,
  onSuccess
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  const { Username } = storeGet(STORE_KEY_USER)
  const date = new Date(Date.now())
    .toISOString()
    .replace('T', ' ')
    .replace(/\.\d+Z/, ' UTC')

  const notes = getIntl().formatMessage(
    { id: 'Load.Messages.CopyNotesUnknown' },
    {
      0: idMessage,
      1: Username,
      2: date
    }
  )

  try {
    await beMessApiCopyMessage(idMessage, notes)
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess()
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}

export const exportResults = ({ set, snapshot }) => async (type, onSuccess) => {
  const search = await snapshot.getPromise(searchState)

  try {
    await exportEmailMessages(search, type)
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess()
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }
}

export const unarchiveMessagesCallback = ({ snapshot, set }) => async (
  messageIds,
  onSuccess
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const filterBY = messageIds.map(o => ` Id == ${parseInt(o)}`).join(' || ')

  try {
    await beMessApiSetArchived(idList, false, filterBY)
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess()
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
  set(selectedResultsState, [])
}

export const archiveMessagesCallback = ({ snapshot, set }) => async (
  messageIds,
  onSuccess
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  const messages = await snapshot.getPromise(resultsState)
  const notToArchive = messages.items.filter(
    o => messageIds.includes(o.Id) && o.isActiveMessage
  )
  const notToArchiveIds = notToArchive.map(o => o.Id)

  const toArchive = messageIds.filter(msgId => !notToArchiveIds.includes(msgId))

  //
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const filterBY = toArchive.map(o => ` Id == ${parseInt(o)}`).join(' || ')

  try {
    if (toArchive.length > 0) {
      await beMessApiSetArchived(idList, true, filterBY)
    }
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess(toArchive, notToArchive)
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
  set(selectedResultsState, [])
}

export const setPublicMessagesCallback = ({ snapshot, set }) => async (
  messageIds,
  publish,
  onSuccess
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const filterBY = messageIds.map(o => ` Id == ${parseInt(o)}`).join(' || ')

  try {
    await beMessApiSetPublic(idList, publish, filterBY)
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess()
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }
  set(selectedResultsState, [])
  set(pageState, prev => ({
    ...prev,
    fetchingResults: false
  }))
}

export const isSendingRunningMessageCallback = ({
  snapshot,
  set
}) => async idMessage => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const result = await beSendGoApiExistSendingRunningMessage(idMessage)
    return result
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const getEntitiesThatUseMessageCallback = ({
  set
}) => async idMessage => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const result = await beMessApiGetEntitiesThatUseMessage(idMessage)
    return result
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const deleteMessagesCallback = ({ snapshot, set }) => async (
  messageIds,
  onSuccess
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const { items: messages } = await snapshot.getPromise(resultsState)

    const messagesUsageCalls = messageIds.map(idMessage =>
      getEntitiesThatUseMessage(idMessage).then(entities => ({
        idMessage,
        entities,
        onSent: false
      }))
    )

    const messagesUsage = await Promise.all(messagesUsageCalls)

    const messagesOnSentCalls = messagesUsage
      .filter(o => !o.entities.length)
      .map(({ idMessage }) =>
        beSendGoApiExistSendingRunningMessage(idMessage).then(onSent => ({
          idMessage,
          entities: [],
          onSent
        }))
      )

    const messagesOnSent = (await Promise.all(messagesOnSentCalls)).filter(
      o => o.onSent
    )

    const messagesToDelete = messageIds.filter(idMessage => {
      const usage = messagesUsage.find(
        o => o.idMessage === idMessage && o.entities.length
      )
      const onSent = messagesOnSent.find(
        o => o.idMessage === idMessage && o.onSent
      )
      return !(usage || onSent)
    })

    //

    const collabProjects = await collaborationApiGetAccountProjects(
      [
        COLLABORATION_PROJECT_STATUS_OPEN,
        COLLABORATION_PROJECT_STATUS_APPROVED,
        COLLABORATION_PROJECT_STATUS_ARCHIVED
      ],
      messagesToDelete.map(idMessage => `NL_${idMessage}`)
    )

    const collabProjectsToDeleteCalls = collabProjects.Items.length
      ? collabProjects.Items.map(p =>
          collaborationApiDeleteProject(p.IdProject)
        )
      : []
    //

    const messagesToDeleteCalls = messagesToDelete.map(idMessage =>
      beMessApiDeleteMessage(idMessage)
    )

    await Promise.all(collabProjectsToDeleteCalls)

    logAppInfo({
      Component: 'MessageList',
      Method: 'deleteMessagesCallback',
      Message: 'Inizio eliminazione newsletter',
      Data: JSON.stringify(messagesToDelete)
    })

    await Promise.all(messagesToDeleteCalls)

    logAppInfo({
      Component: 'MessageList',
      Method: 'deleteMessagesCallback',
      Message: 'Fine eliminazione newsletter'
    })

    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess(
        [
          ...messagesUsage.filter(o => o.entities.length),
          ...messagesOnSent
        ].map(o => ({
          ...o,
          subject: messages.find(m => m.Id === o.idMessage).Subject
        })),
        messagesToDelete.map(idMessage => ({
          idMessage,
          subject: messages.find(m => m.Id === idMessage).Subject
        }))
      )
    }
  } catch (error) {
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
    set(selectedResultsState, [])
  }
}

export const getCollaborationLoginDataCallback = ({ snapshot, set }) => async (
  idMessage,
  idProject,
  subject,
  hideResolvedThreads
) => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const account = storeGet(STORE_KEY_ACCOUNT)

    const IsWhiteLabel = evalCondition('co:WHITELABEL')

    const projectUrl = `https://${
      account.Domain
    }/frontend/nl_preview_window.aspx?idNL=${idMessage}&fc=${btoa(
      `${idMessage}`
    )}&hideAtt=1`

    const { AppName, LogoutUrl } = await beAccountsApiGetAccountCustomSettings()

    const customizations = IsWhiteLabel
      ? {
          customizations: [
            {
              Key: 'companylogourl',
              Value: `https://${account.Domain}/img/ApplicationLogo.jpg`
            },
            { Key: 'companyname', Value: AppName },
            { Key: 'companyurl', Value: LogoutUrl }
          ]
        }
      : {}

    const data = idProject
      ? {
          IdProject: idProject,
          navigation: 'True',
          hideresolvedthreads: hideResolvedThreads ? 'True' : 'False',
          ...customizations
        }
      : {
          projectReference: `NL_${idMessage}`,
          htmlUrl: projectUrl,
          projectName: subject,
          ...customizations
        }

    const result = await collaborationApiGetLoginData(data)
    return result
  } catch (error) {
    logAppError({ appError: error })

    return false
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

export const downloadHtmlMessageCallback = ({
  snapshot,
  set
}) => async idMessage => {
  let ret
  set(pageState, prev => ({
    ...prev,
    downloadFile: true
  }))
  const showToast = () => {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailMessageOverview.DownloadError'
      }),
      TOAST_VARIANT_ERROR,
      'DownloadHtmlError'
    )
  }
  try {
    const content = await getMessageHtmlExport(idMessage)
    if (content) {
      ret = content.Content
    } else {
      showToast()
    }
  } catch (error) {
    showToast()
  }
  set(pageState, prev => ({
    ...prev,
    downloadFile: false
  }))
  return ret
}

export const downloadPdfMessageCallback = ({
  snapshot,
  set
}) => async idMessage => {
  let ret
  set(pageState, prev => ({
    ...prev,
    downloadFile: true
  }))
  const showToast = () => {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailMessageOverview.DownloadError'
      }),
      TOAST_VARIANT_ERROR,
      'DownloadHtmlError'
    )
  }
  try {
    const content = await getMessagePdfExport(idMessage)
    if (content) {
      ret = content.Content
    } else {
      showToast()
    }
  } catch (error) {
    showToast()
  }
  set(pageState, prev => ({
    ...prev,
    downloadFile: false
  }))
  return ret
}

export const fetchCollaborationCallback = ({ snapshot, set }) => async () => {
  const ids = await snapshot.getPromise(collaborationState)

  const collaborationResults = await fetchCollaborationResults(ids)

  set(messagesCollaborationState, collaborationResults)
}
